import React from 'react';
import { QToolbar as MuiSidebarToolbar } from '@kw/quokka-ui';

export const QSidebarToolbar = ({ children, ...props }) => (
  <MuiSidebarToolbar {...props}>{children}</MuiSidebarToolbar>
);
